import { Vue } from 'vue-class-component';

import ProductsUtils from './ProductsUtils';
import { process, DataResult, State, SortDescriptor } from '@progress/kendo-data-query';
import { Component, Prop, Watch } from 'vue-property-decorator';
import _, { filter, forEach } from 'lodash';
import { GridPageChangeEvent, GridSortChangeEvent, GridDataStateChangeEvent } from '@progress/kendo-vue-grid';
import * as moment from "moment";

import OrdersSearchService from '../services/OrdersSearchService';

import { resources } from '../resources';

import OrderService from '../services/OrderService';

export default class MyAccountOrders extends Vue {
    @Prop(String)
    public languageId: string = 'it-IT';

    @Prop(Number)
    public accountId: number = 0;

    @Prop(Number)
    public accountUserId: number = 0;

    @Prop(Boolean)
    public ordersListLite: boolean = false;

    public searchTerm: string = '';

    public ordersData: DataResult | null = null;

    public listColumns: any[] | null = null;

    public sort: SortDescriptor[] = [];

    private actualSort: SortDescriptor[] = [];

    public pageable: boolean = true;
    public sortable: boolean = true;

    public skip: number = 0;
    public take: number = 10;
    public total: number = 0;

    public resources = resources;

    public searchIsLoading: boolean = true;

    private orders: any[] = [];

    private searchService: OrdersSearchService | null = null;

    private orderService: OrderService | null = null;

    private currentSearchId: number | null = null;

    private windowWidth: number = window.innerWidth;

    @Watch("windowWidth", { immediate: true })
    private refreshColumns(width: number) {
        var instance = this;

        if (width > 959) {
            instance.listColumns = [
                { field: 'id', title: instance.resources['OrdersList_Columns_Code'], cell: 'orderCode' },
                { field: 'createDate', title: instance.resources['OrdersList_Columns_CreateDate'], cell: 'createDate' },
                { field: 'totalProducts', title: instance.resources['OrdersList_Columns_Items'] },
                { field: 'orderState', title: instance.resources['OrdersList_Columns_OrderState'], cell: 'orderState' },
                { field: 'paymentState', title: instance.resources['OrdersList_Columns_PaymentState'], cell: 'paymentState' },
                { field: 'grandTotal', title: instance.resources['OrdersList_Columns_GrandTotal'], cell: 'orderTotalAmount' },
            ];
        } else {
            instance.listColumns = [
                { field: 'id', title: instance.resources['OrdersList_Columns_Code'], cell: 'orderCode' },
                { field: 'createDate', title: instance.resources['OrdersList_Columns_CreateDate'], cell: 'createDate' },
                { field: 'totalProducts', title: instance.resources['OrdersList_Columns_Items'], hidden: true },
                { field: 'orderState', title: instance.resources['OrdersList_Columns_OrderState'], cell: 'orderState', hidden: true },
                { field: 'paymentState', title: instance.resources['OrdersList_Columns_PaymentState'], cell: 'paymentState', hidden: true },
                { field: 'grandTotal', title: instance.resources['OrdersList_Columns_GrandTotal'], cell: 'orderTotalAmount' },
            ];
        }
    }

    onFilterChanged() {
        var instance = this;

        instance.skip = 0;

        instance.currentSearchId = Math.random();

        instance.pushSearchHistory();

        instance.fetchData(instance.currentSearchId);
    }

    onPageChanged(e: GridPageChangeEvent) {
        this.skip = e.page.skip;

        this.bindData();

        this.pushSearchHistory();
    };

    onSortChanged(e: GridSortChangeEvent) {
        this.sort = e.sort;

        this.rebuildActualSort();

        this.doSort();

        this.pushSearchHistory();
    }

    rebuildActualSort() {
        this.actualSort.splice(0, this.actualSort.length);

        for (var i = 0; i < this.sort.length; i++) {
            var thisSortField = this.sort[i].field;

            if (thisSortField == 'orderState')
                thisSortField = 'orderState_Num';
            else if (thisSortField == 'paymentState')
                thisSortField = 'paymentState_Num';

            this.actualSort.push({ field: thisSortField, dir: this.sort[i].dir });
        }
    }

    doSort() {
        this.orders = ProductsUtils.orderBy(this.orders, this.actualSort);

        this.bindData();
    }

    private pushSearchHistory(): void {
        var instance = this;

        // build query string
        var page: number = instance.getPageIndex() + 1;

        // page
        var querystring = `?page=${page}`;

        // order by
        if (instance.sort.length > 0) {
            var orderBySerialized = ProductsUtils.getOrderByQueryStringParam(instance.sort);
            querystring += `&orderby=${orderBySerialized}`;
        }

        if (instance.searchTerm) {
            querystring += `&q=${instance.searchTerm}`;
        }

        var pathAndQueryString = location.pathname + querystring;

        history.pushState(null, '', pathAndQueryString);
        instance.searchService?.pushSearchHistory(pathAndQueryString, instance.languageId);
    }

    private rebuildFiltersFromHistoryState(): boolean {
        var instance = this;

        var prevSearchTerm = instance.searchTerm;

        // set defaults
        instance.searchTerm = '';
        instance.skip = 0;
        instance.sort = [
            { field: 'createDate', dir: 'desc' }
        ];

        if (location.search && location.search != '') {
            var urlParams = new URLSearchParams(location.search);

            urlParams.forEach((value: string, key: string) => {
                if (!value || value == '')
                    return;

                switch (key.toLowerCase()) {
                    case "page":
                        var pageNumber = Number(value);

                        if (pageNumber != NaN) {
                            instance.skip = (pageNumber - 1) * instance.take;
                        }

                        break;

                    case "orderby":
                        var sortByQueryString = ProductsUtils.getSortByOrderByQueryStringParam(value);

                        instance.sort.splice(0, instance.sort.length);
                        instance.sort.push.apply(instance.sort, sortByQueryString);

                        instance.rebuildActualSort();

                        break;

                    case "q":
                        instance.searchTerm = value;

                        break;
                }
            });
        }

        return (instance.searchTerm != prevSearchTerm);
    }

    private getPageIndex(): number {
        return (this.take > 0 ? this.skip / this.take : 0);
    }

    private fetchData(thisSearchId: number | null) {
        var instance = this;

        var instance = this;

        var pageIndex: number | null = null, pageSize: number | null = null;

        if (instance.ordersListLite) {
            pageIndex = 0;
            pageSize = instance.take;
        }

        var pathAndQueryString = (location.pathname + location.search);

        instance.searchService?.searchOrders(instance.accountUserId, instance.languageId, instance.searchTerm, pageSize, pageIndex, pathAndQueryString)
            .then((res: any) => {
                if (instance.currentSearchId != thisSearchId) {
                    return;
                }

                var thisOrders = res.results.items;
                instance.total = res.results.totalCount as number;

                if (!instance.orders) {
                    instance.orders = [];
                }

                if (instance.orders.length > 0) {
                    instance.orders.splice(0, instance.orders.length);
                }

                instance.orders.push.apply(instance.orders, thisOrders);

                // apply binding with client sorting
                instance.doSort();

                instance.searchIsLoading = false;
            });
    }

    private bindData(): void {
        var thisOrders = ProductsUtils.page(this.orders || [], this.skip, this.take);

        const dataState = {};

        this.ordersData = process(thisOrders, dataState);
    }

    private toDateString(date: any): string {
        return date ? moment(date).locale(this.languageId).format("L") : "-";
    }

    onHistoryPopState(event: PopStateEvent) {
        var instance = this;

        var needsRefetch = instance.rebuildFiltersFromHistoryState();

        if (needsRefetch) {
            instance.currentSearchId = null;
            instance.fetchData(null);
        }
        else {
            instance.doSort();
        }
    }

    created() {
        var instance = this;

        if (instance.ordersListLite) {
            instance.pageable = false;
            instance.sortable = false;
            instance.sort = [];
            instance.take = 4;
        }


        instance.orderService = new OrderService();
        instance.searchService = new OrdersSearchService();
        instance.actualSort = instance.sort;

        // moved to windowWidth Watch
        // instance.listColumns = [];

        instance.rebuildFiltersFromHistoryState();

        // show loader only in first search
        instance.searchIsLoading = true;

        instance.fetchData(null);

        window.addEventListener('popstate', instance.onHistoryPopState);
    }

    mounted() {
        var instance = this;

        window.addEventListener("resize", () => {
            instance.windowWidth = window.innerWidth;
        })
    }
    oncompletePayment(orderid: number) {
        var instance = this;
        $('.loading-overlay-fixed').show();
        console.log(orderid)
        instance.orderService.completePayment(orderid, instance.languageId)
            .then((res: any) => {

                $('.loading-overlay-fixed').hide();
                if (res.success) {
                    history.pushState({ reload: true }, '', window.location.pathname + window.location.search);
                    window.location.href = res.redirectUrl;
                }
                else {
                    UIkit.modal("#modal-message").show();
                    $('.errorcontaner').html("");
                    $('.errorcontaner').show();
                    $.each(res.messages, function (i, item) {
                        $('.errorcontaner').append(item.text + "<br/>")


                    });
                }

                //instance.searchResponse = res;
            });
    }


}